import React, { useCallback } from 'react'
import ModalBase from 'LuxKit/Modal/ModalBase'
import ModalBody from 'LuxKit/Modal/ModalBody'
import SocieteNotificationCard from './SocieteNotificationCard'
import SocieteCompletionCard from './SocieteCompletionCard'
import useModalElementContext from 'hooks/Modal/useModalElementContext'

import { useAppDispatch } from 'hooks/reduxHooks'
import updateEmployeeNotification from 'actions/businessTraveller/updateEmployeeNotification'
import { EMPLOYEE_NOTIFICATION_DISMISS_PAYLOAD } from 'businessTraveller/constants/employeeNotificationConstant'

interface Props {
  notificationType: App.BusinessTraveller.SocieteNotificationType
}

function SocieteNotificationModal({ notificationType }: Props) {
  const modalState = useModalElementContext<'dismissed'>()
  const dispatch = useAppDispatch()

  const handleDismiss = useCallback(() => {
    dispatch(updateEmployeeNotification(EMPLOYEE_NOTIFICATION_DISMISS_PAYLOAD[notificationType]))
    modalState?.resolve('dismissed')
  }, [dispatch, modalState, notificationType])

  if (notificationType === 'COMPLETION') {
    return <ModalBase mode="default" onClose={handleDismiss}>
      <ModalBody>
        <SocieteCompletionCard onDismiss={handleDismiss} />
      </ModalBody>
    </ModalBase>
  }

  return <ModalBase mode="default" onClose={handleDismiss}>
    <ModalBody>
      <SocieteNotificationCard notificationType={notificationType} onDismiss={handleDismiss} />
    </ModalBody>
  </ModalBase>
}

export default SocieteNotificationModal
